const watchAll = require('./watch-all');
const toValues = require('./to-values');

/**
 * Process a stream for a query, filtering pending values and ensuring a full value
 * set is returned on every emission. Maintains the order of the requested paths,
 * and strips paths from the returned objects, emitting only an array of values
 * @param {Observable} stream - the output of a muster `get` query
 * @returns {Observable<Array<*>>} - a stream that will emit any time
 * any of the source paths emits, emitting an array of values for the requested paths
 */
function watchValues(stream) {
  return watchAll(stream).map(toValues);
}

module.exports = watchValues;
